// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CkmKyPr1ZeP4NWCjLtyM{padding:12px;width:338px}.lQevb__AKKW2h1ZihkzG{border-top:1px solid var(--border-neutral-default)}`, "",{"version":3,"sources":["webpack://./src/pages/campaigns/ui/CampaignSchedule/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,WAAA,CAEF,sBACE,kDAAA","sourcesContent":[".wrapTabs {\n  padding: 12px;\n  width: 338px;\n}\n.wrapSendLater {\n  border-top: 1px solid var(--border-neutral-default);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapTabs": `CkmKyPr1ZeP4NWCjLtyM`,
	"wrapSendLater": `lQevb__AKKW2h1ZihkzG`
};
export default ___CSS_LOADER_EXPORT___;
